/**
 * How urgent an expiry reminder looks. The server decides the reminder points (60, 30, 14 and 7
 * days, see the backend's expiry.util.ts) and which one has been crossed; the panel only picks
 * the colour: the first two warn, the last two are urgent.
 */
export const expiryReminderSeverity = (reminderDays: number): 'warning' | 'error' =>
  reminderDays <= 14 ? 'error' : 'warning';

export const expiresInText = (days: number) => days === 1 ? 'in 1 day' : `in ${days} days`;
